var map = {
	"./applab/skins": 2431,
	"./bounce/skins": 2835,
	"./craft/agent/skins": 2839,
	"./craft/code-connection/skins": 2840,
	"./craft/designer/skins": 2838,
	"./craft/simple/skins": 2837,
	"./flappy/skins": 2842,
	"./jigsaw/skins": 2855,
	"./maze/skins": 2103,
	"./netsim/skins": 2882,
	"./p5lab/skins": 2311,
	"./studio/skins": 2884,
	"./studio/starwars/skins": 2458,
	"./turtle/skins": 2496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4236;